<!-- <p>inventory-form-dialog works!</p> -->
<div
  [ngClass]="{
    'create-inventory': screenSize === 1 || screenSize === 2,
    'create-inventory-mobile': screenSize === 3
  }"
>
  <div class="close-header">
    <button mat-mini-fab mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <form [formGroup]="inventoryForm">
    <mat-grid-list
      [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
      rowHeight="85"
      gutterSize="10px"
    >
      <!-- List Name -->
      <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 1 : 2">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>List Name </mat-label>
          <input matInput formControlName="listName" />
        </mat-form-field>
      </mat-grid-tile>
      <!-- Price and Quantity Tile -->

      <mat-grid-tile
        [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
        [rowspan]="screenSize == ScreenType.Mobile ? 4 : 1"
        *ngFor="let item of inventoryItems.controls; let i = index"
      >
        <!-- Price and Quantity input fields -->
        <div formArrayName="items" style="width: 100%; height: 100%">
          <div class="price-quantity-tile" [formGroupName]="i">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Item {{ i + 1 }}</mat-label>
              <input matInput formControlName="itemName" />
            </mat-form-field>
            <!-- <mat-form-field appearance="outline" subscriptSizing="dynamic" >
              <mat-label>Price</mat-label>
              <input
                matInput
                formControlName="price"
                (keypress)="inputValidator($event)"
              />
              <mat-icon matSuffix>₹</mat-icon>
            </mat-form-field> -->
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Quantity</mat-label>
              <input
                matInput
                formControlName="quantity"
                (keypress)="inputValidator($event)"
              />
              <mat-icon matSuffix>local_grocery_store</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Metric</mat-label>
              <mat-select formControlName="units">
                <mat-option value="kg">kg</mat-option>
                <mat-option value="g">g</mat-option>
                <mat-option value="mg">mg</mat-option>
                <mat-option value="liter">liter</mat-option>
                <mat-option value="ml">ml</mat-option>
                <mat-option value="dozen">dozen</mat-option>
                <mat-option value="unit">unit</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="button-container">
              <button
                mat-mini-fab
                *ngIf="inventoryItems.controls.length != 1"
                (click)="removeItem(i)"
              >
                <mat-icon>remove</mat-icon>
              </button>
              <button
                mat-mini-fab
                *ngIf="inventoryItems.controls.length - 1 === i"
                (click)="addItem()"
                [disabled]="inventoryItems.controls[i].invalid"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </mat-grid-tile>
      <mat-grid-tile *ngIf="false">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Discount</mat-label>
          <input matInput formControlName="discount" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile *ngIf="false">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Total Bill Amount</mat-label>
          <input matInput formControlName="billAmount" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field subscriptSizing="dynamic" appearance="outline">
          <mat-label>Assign Event</mat-label>
          <mat-select formControlName="assignEvent">
            <mat-option>-- None --</mat-option>
            <mat-option
              *ngFor="let event of userEvents"
              [value]="event.eventId"
              >{{ event.eventTitle }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field subscriptSizing="dynamic" appearance="outline">
          <mat-label>Assign Vendor Request</mat-label>
          <mat-select formControlName="assignVendor">
            <mat-option>-- None --</mat-option>
            <mat-option
              *ngFor="let request of vendorRequests"
              [value]="request.complainId"
              >{{ request.complainDescription }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Delivery Date</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="deliveryDate"
            [min]="minDate"
            [max]="maxDate"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Delivery By</mat-label>
          <input
            matInput
            [formControl]="hostFilter"
            [matAutocomplete]="autoAdmin"
          />
          <mat-autocomplete
            (optionSelected)="hostSelect($event)"
            #autoAdmin="matAutocomplete"
          >
            <mat-option
              *ngFor="let host of filteredUsers"
              [value]="host.firstname + ' ' + host.lastname"
            >
              {{ host.firstname + " " + host.lastname }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <div class="radio-button-container">
          <mat-radio-group
            formControlName="addressType"
            (change)="onAddressTypeChange($event)"
          >
            <mat-radio-button value="1" [disabled]="!isAddressAvailable"
              >Current Address</mat-radio-button
            >
            <mat-radio-button value="2">New Address</mat-radio-button>
          </mat-radio-group>
        </div>
      </mat-grid-tile>
      <mat-grid-tile *ngIf="inventoryForm.get('addressType').value === '2'">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>New Address</mat-label>
          <input matInput formControlName="deliveryAddress" />
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <div class="checkbox-container">
          <mat-checkbox
            (change)="onCheckboxChange()"
            formControlName="sendCode"
          >
            Send Invite Code</mat-checkbox
          >
        </div>
      </mat-grid-tile>
      <mat-grid-tile
        *ngIf="isShowSaveMessage && screenSize === 3"
        [colspan]="1"
      >
        <div class="saving-message">
          Saving user list... <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      </mat-grid-tile>

      <mat-grid-tile>
        <div class="button-inside-mat-grid">
          <button
            [disabled]="inventoryForm.invalid"
            (click)="onSaveForm()"
            mat-raised-button
          >
            Save List
          </button>
        </div>
      </mat-grid-tile>
      <mat-grid-tile *ngIf="false" colspan="2" rowspan="2">
        {{ inventoryForm.value | json }}||| {{ inventoryForm.invalid | json }}
      </mat-grid-tile>
      <mat-grid-tile *ngIf="isShowSaveMessage && screenSize != 3" [colspan]="2">
        <div class="saving-message">
          Saving user list... <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</div>
